import React, { useContext } from 'react'
import axios from "axios";
import './../css/login.css'
import DataContext from "./../data/DataContext";
import Swal from 'sweetalert2'

function Login() {
    const dataConf = useContext(DataContext)
    const formSubmit = async (e)=>{
        e.preventDefault()
        const a_user = e.target.l_user.value
        const a_pass = e.target.l_pass.value
        dataConf.blockUI()
        const response = await axios.post(
            `${dataConf.ApiURL}/admin/auth`,
              {
                p_username:a_user,
                p_password:a_pass,
              },
              {
                  headers:{   }
              }
        ).then((res)=>{
            dataConf.blockUI()
            dataConf.loginAccess(res.data.data.a_id,res.data.data.a_user,res.data.data.a_name,res.data.data.a_login,res.data.data.a_level,res.data.data.a_pass)
            localStorage.setItem('_id',res.data.data.a_id,60000)
            localStorage.setItem('username',res.data.data.a_user,60000)
            localStorage.setItem('name',res.data.data.a_name,60000)
            localStorage.setItem('login',res.data.data.a_login,60000)
            localStorage.setItem('level',res.data.data.a_level,60000)
            localStorage.setItem('pass',res.data.data.a_pass,60000)
        })
        .catch((error) => {
            dataConf.blockUI()
            Swal.fire({
                title: error.response.data.message,
                text:'',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#890000',
            })
        });
    }
  return (
    <div id="login" className="login-session" style={{backgroundImage: `url("/web/${process.env.REACT_APP_SITE}/bg_ohoking.jpeg")`,backgroundSize:'cover',backgroundPosition:'center',height:'100vh'}}>
        <div className="container text-center">
            <div className="login-logo pt-5 ">
                <a className="py-0 pt-5 mb-5 m-auto p-auto d-block" href="#">
                    <img src={`/web/${process.env.REACT_APP_SITE}/logo.png`} alt="" className="w-25" />
                </a>
            </div>
            <div className="mx-auto col-md-5 col-xl-4">
                <div className="bg-white px-3 py-4 rounded">
                <form className="form" id="login_frm" onSubmit={formSubmit}>
                    <div className="form-group mb-2">
                        <input className="form-control form-control-sm mr-sm-2" type="text" placeholder="ชื่อผู้ใช้" name="l_user"   />
                    </div>
                    <div className="form-group mb-3">
                        <input className="form-control form-control-sm mr-sm-2" type="password" placeholder="รหัสผ่าน" name="l_pass"  />
                    </div>
                    <div className="form-group mb-0">
                        <button type="submit" className="btn btn-sm btn-login w-100 control-oho">เข้าสู่ระบบ</button>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Login